module.exports = "query getUserGroups{groupList{id name}}"